module.exports = __webpack_public_path__ + "static/media/truck.be888861.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/truck.pdf
// module id = 2049
// module chunks = 0